module.exports = __webpack_public_path__ + "img/tab-content-01.58ec633d.jpg";